<template>
  <div>
    <div
      class="tai-xiu-bet-lot-cell"
      :class="{'tai-xiu-bet-lot-cell-active': win, [size]: size, [type]: type}"
    >
      <Row
        class="tai-xiu-bet-lot-title"
        :class="{[size]: size}"
        type="flex"
        justify="center"
        align="middle"
      >
        <span v-html="$t(`${gameSnakeCase}.${type}`)"></span>
      </Row>
      <Row
        class="tai-xiu-bet-lot-bet-no"
        :class="{[size]: size}"
        type="flex"
        justify="center"
      >{{odd}}</Row>
      <div class="tai-xiu-bet-range" v-if="type ==='o1'">[11-17]</div>
      <div class="tai-xiu-bet-range" v-else-if="type === 'o2'">[4-10]</div>
      <div class="tai-xiu-bet-range" v-else-if="type === 'o3'">&nbsp;</div>
      <div v-if="stakeRecordSum" class="tai-xiu-bet-lot-stake-total">{{stakeRecord}}</div>
    </div>
  </div>
</template>

<script>
import { Row } from "iview";
import { snakeCase } from "change-case";

export default {
  props: ["type", "odd", "win", "game", "size", "stakeRecordSum"],
  components: {
    Row
  },
  computed: {
    gameSnakeCase() {
      return snakeCase(this.game);
    },
    stakeRecord() {
      return display_numeric(this.stakeRecordSum);
    }
  }
};
</script>


<style lang="scss" scoped>
.locale_3 .tai-xiu-game .o3 .tai-xiu-bet-lot-title,
.locale_5 .tai-xiu-game .o3 .tai-xiu-bet-lot-title {
  font-size: 10px;
  line-height: 18px;
}

.tai-xiu-bet-lot-cell {
  @extend .tai-xiu-game-cell;
  width: 100%;
  text-align: center;
  padding: 8px 0;
}

.tai-xiu-bet-lot-title {
  @extend .tai-xiu-game-title;
}

.tai-xiu-bet-lot-bet-no {
  @extend .tai-xiu-game-bet-no;
}

.tai-xiu-bet-lot-title.small {
  height: unset;
  // margin-top: 5px;
}

.tai-xiu-bet-lot-bet-no.small {
  height: unset;
}
</style>



<style lang="scss">
.tai-xiu-bet-lot-cell {
  @extend .tai-xiu-game-btn;
}

.tai-xiu-bet-lot-cell.tai-xiu-bet-lot-cell-active .tai-xiu-bet-lot-title,
.tai-xiu-bet-lot-cell.tai-xiu-bet-lot-cell-active .tai-xiu-bet-lot-bet-no {
  @extend .tai-xiu-game-btn-active;
}

.tai-xiu-bet-lot-cell:hover {
  @extend .tai-xiu-game-btn-hover;
}

.tai-xiu-bet-lot-stake-total {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  text-align: center;
  font-weight: bold;
  font-size: 11px;
  padding: 5px;
  background: $tai-xiu-theme-color-3;
  color: $tai-xiu-theme-color-5;
  border-bottom-left-radius: 8px;
  max-height: 16px;
  line-height: 16px;
}
.tai-xiu-bet-range {
  font-size: 10px;
  color: #bbb;
  font-weight: bold;
}

@media only screen and (max-width: 360px) {
}
</style>
